<div class="fx-ib-mam-history card bg-dark-lighter text-white">
  <div class="card-body fx-ib-mam-history__create">
    <div class="p-15">
      <div class="row">
        <div class="col font-bold fs-15">
          {{'Create mam master'}}
          <span class="d-block fs-12 text-red">Please enter email to process create mam master.</span>
        </div>
      </div>
      <form class="form" #formMam="ngForm" autocomplete="off"
            (ngSubmit)="onCreateMamMaster()">
        <div class="row mt-4" create-permission>
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>Email</mat-label>
              <input
                type="email"
                name="txtEmail"
                class="email-auto"
                placeholder=""
                (keyup)="searchAccount()"
                [(ngModel)]="formCreate.txtEmail"
                matInput
                [formControl]="myControlCreate"
                [matAutocomplete]="auto"
                required
                readonly="{{!permission.allowCreating}}"
              >
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let option of listAccountComplete" [value]="option">
                  {{option.email}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>{{'Name'}}</mat-label>
              <input
                matInput
                class=""
                type="text"
                placeholder=""
                name="name"
                [(ngModel)]="myControlCreate.value.name"
                #name="ngModel"
                disabled
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>Group Name</mat-label>
              <mat-select name="group" [(ngModel)]="formCreate.group" required
                          disabled="{{!permission.allowCreating}}">
                <mat-option *ngFor="let item of mamGroupName" [value]="item">
                  <span labelGroup="{{item}}"></span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>Allocation Method</mat-label>
              <mat-select name="allowMethod" [(ngModel)]="formCreate.allowMethod" required
                          disabled="{{!permission.allowCreating}}">
                <mat-option *ngFor="let item of listAllowMethod" [value]="item">
                  {{ item.replace('_', ' ') }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6 col-xs-12">
            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill" floatLabel="auto">
                  <mat-label>{{'Pip'}}</mat-label>
                  <input
                    matInput
                    type="number"
                    placeholder=""
                    name="pip"
                    [(ngModel)]="formCreate.pip"
                    #pip="ngModel"
                    required
                    disabled="{{!permission.allowCreating}}"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="fill" floatLabel="auto">
                  <mat-label>{{'Commission'}}</mat-label>
                  <input
                    matInput
                    type="number"
                    placeholder=""
                    name="commission"
                    [(ngModel)]="formCreate.commission"
                    #commission="ngModel"
                    required
                    disabled="{{!permission.allowCreating}}"
                  />
                  <span matSuffix>%</span>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>{{'Percentage'}}</mat-label>
              <input
                matInput
                type="number"
                placeholder=""
                name="rate"
                [(ngModel)]="formCreate.rate"
                #rate="ngModel"
                required
                disabled="{{!permission.allowCreating}}"
              />
              <span matSuffix>%</span>
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>{{'HWM Percentage'}}</mat-label>
              <input
                matInput
                type="number"
                placeholder=""
                name="rate"
                [(ngModel)]="formCreate.ratePayout"
                #rate="ngModel"
                required
                disabled="{{!permission.allowCreating}}"
              />
              <span matSuffix>%</span>
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-2" create-permission>
          <div class="col-md-6 col-xs-12">
            <button class="btn btn-main w-100 font-bold" type="submit">Apply</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <hr>
  <div class="card-body">
    <div class="p-15">
      <div class="row mb-15">
        <div class="col-md-6 col-xs-12">
          <div
            class="input-group search-group">
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              [(ngModel)]="condition.keyword"
              (keydown.enter)="searchTransaction()"
              placeholder="Search"/>
            <div class="input-group-append">
              <button
                class="btn btn-main"
                type="button"
                (click)="searchTransaction()"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="table-responsive">
            <form class="form" name="form">
              <table class="rox-table table-bordered bg-dark">
                <thead>
                <tr>
                  <th class="text-center">No</th>
                  <th class="text-center">User Name</th>
                  <th class="text-center">Email</th>
                  <th class="text-center">MT5 Group</th>
                  <th class="text-center" create-permission></th>
                </tr>
                </thead>
                <tbody>
                <tr
                  *ngFor="
                          let item of data
                            | paginate
                              : {
                                  id: 'mamMaster',
                                  itemsPerPage: pageInfo.pageSize,
                                  currentPage: pageInfo.pageIndex,
                                  totalItems: pageInfo.totalRecord
                                };
                          let i = index
                        ">
                  <td class="text-center">{{item.userId}}</td>
                  <td class="text-center">{{item.getUsername()}}</td>
                  <td class="text-center">{{item.email}}</td>
                  <td class="text-center">
                    <select class="{{(!permission.allowCreating) ? 'ignore-click' : ''}}">
                      <option *ngFor="let setting of item.groupConfigs">
                        <span labelGroup="{{setting.group}}"></span>
                      </option>
                    </select>
                  </td>
                  <td class="text-center" create-permission>
                    <a
                      href="javascript:void(0)"
                      class="text-blue-lighter"
                      (click)="getMamMasterInfo(item)"
                      data-bs-toggle="modal"
                      data-bs-target="#modalMamMasterIB"
                    >View</a>
                  </td>
                  <!--<td class="text-center action-change">-->
                    <!--<button class="btn btn-up" type="button" data-bs-toggle="modal" data-bs-target="#modalChangeGroupName"-->
                            <!--(click)="onChangeProcess(1, item.id)">Approval</button>-->
                    <!--<button class="btn btn-down" type="button" (click)="onChangeProcess(2, item.id)">Reject</button>-->
                  <!--</td>-->
                </tr>
                </tbody>
              </table>
            </form>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="mamMaster"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- CHANGE GROUP NAME MODAL -->
  <div class="modal fade fx-modal" id="modalMamMasterIB">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-shadow">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0">{{ mamMasterIBInfo.name }}</h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <table class="rox-table table-bordered bg-dark" *ngIf="mamMasterIBInfo.data">
            <thead>
            <tr>
              <th class="text-center">MT5 Account</th>
              <th class="text-center">MT5 Group</th>
              <th class="text-center">Allocation Method</th>
              <th class="text-center">HWM Percentage (%)</th>
              <th class="text-center"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of mamMasterIBInfo.data; let i = index">
              <td class="text-center">{{ item.login }}</td>
              <td class="text-center">
                <span labelGroup="{{item.group}}"></span>
              </td>
              <td class="text-center">{{ item.allocation_method }}</td>
              <td class="text-center">
                <input type="number" [(ngModel)]="item.percent" [disabled]="!isEdit || currentIndexEdit != item.login">
              </td>
              <td class="text-center">
                <i class="fa fa-save" role="button"
                   *ngIf="isEdit && currentIndexEdit === item.login" (click)="onSave(item)"></i>
                <i class="fa fa-edit" role="button"
                   *ngIf="!isEdit || currentIndexEdit != item.login" (click)="onEdit(item)"></i>
                <i class="fa fa-ban text-red ml-2" role="button"
                   *ngIf="isEdit && currentIndexEdit === item.login" (click)="onEdit(null)"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade fx-modal" id="modalChangeGroupName" #modalUser>
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">
             The process approve mam account
          </h4>
          <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body mb-3">
          <form class="form mat-form" #form="ngForm" autocomplete="off" (ngSubmit)="onSubmitApprove()">
            <div class="row">
              <mat-form-field appearance="fill" floatLabel="auto">
                <mat-label>Group Name</mat-label>
                <mat-select name="group" [(ngModel)]="options.group" required>
                  <mat-option *ngFor="let item of mamGroupName" [value]="item.id">
                    {{ item.id | titlecase }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="w-100 text-center">
              <button type="submit" class="btn btn-main w-50">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
